((AccountSidebar, $) => {
  const $dom = {
    accordionActiveTab: '[accordion-active-tab]',
    accordionTab: '[accordion-tab]',
  };
  
  const bindUIActions = () => {
    $(document).on('click', $dom.accordionActiveTab, (event) => {
      $(event.currentTarget).toggleClass('account__sidebar-nav-item--active-open')
      $($dom.accordionTab).toggleClass('account__sidebar-nav-item--open');
    });
  };
  
  AccountSidebar.init = () => {
    bindUIActions();
  };
})(window.AccountSidebar = window.AccountSidebar || {}, jQuery);
